import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

const SANS_RETRY = ["/auth/connexion", "/auth/rafraichir", "/auth/deconnexion"];
let rafraichissement = null;

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    if (error.response?.status === 401 && cfg && !cfg._retry && !SANS_RETRY.includes(cfg.url)) {
      cfg._retry = true;
      try {
        rafraichissement = rafraichissement || api.post("/auth/rafraichir");
        await rafraichissement;
        rafraichissement = null;
        return api(cfg);
      } catch {
        rafraichissement = null;
      }
    }
    return Promise.reject(error);
  },
);

export function messageErreur(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.response ? "Une erreur est survenue. Veuillez réessayer." : "Serveur injoignable. Vérifiez votre connexion.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return "Certains champs sont invalides ou manquants.";
  return String(d.msg || d);
}
